(function($){

    if(document.getElementById('destination')){
        var $selectBox        = $('#destination');
        var $destinationEmail = $('#destination_email');
        var destinations      = azdsDefaultSettings.getInTouchFormDestinations;
        var output            = '<option value="">Select Destination</option>';

        destinations.forEach(function(item, i, destinations){
            output = output + '<option value="'+ item.name +'" data-email="'+item.email+'">'+ item.name +'</option>';
        });
        $selectBox.html(output).on('change', function(event){
            var optionSelected = $("option:selected", $(this));
            var dataEmail = optionSelected.attr('data-email');
            $destinationEmail.val(dataEmail);
        });
    }

}(jQuery));
